<script>
  export let size = '30px';
  export let color = '#e40032';
</script>

<div class="spinner-container">
  <div
    class="spinner"
    style="width: {size}; height: {size}; border-color: {color} transparent {color} transparent;"
  ></div>
</div>

<style>
  .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .spinner {
    border: 3px solid;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
